module.exports = __webpack_public_path__ + "background20.jpg?a75c215d9b58c9cc51641d0b24bbaa16";